import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { ApiLinks } from '@cutting/app.api-links';
import { HubConnection } from '@microsoft/signalr';
import {
  connectToGroup,
  customResponse,
  IClientCuttingNotification,
  ICustomResponse,
  startConnection,
} from 'cloud-shared-lib';
import { BehaviorSubject, Observable } from 'rxjs';
import { LocalStorageManager } from '../helper/local-storage-manager.helper';

@Injectable({
  providedIn: 'root',
})
export class NotificationService implements OnDestroy {
  public connection: HubConnection;
  public connected$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public readonly connectToGroup = 'ConnectToCuttingClientGroup';

  public readonly updateHasCommonNotificationsName = 'UpdateHasCommonCuttingNotificationsAsync';
  public readonly hasCommonNotifications = 'HasCommonCuttingNotificationsAsync';

  constructor(private http: HttpClient) {}

  ngOnDestroy(): void {
    this.disconnect();
  }

  connect(/*token: string*/): Promise<void> {
    const client = LocalStorageManager.client;

    if (!client) {
      this.connected$.next(false);
      return Promise.resolve();
    }

    if (!this.connection) {
      const { connection, callback } = startConnection(ApiLinks.cuttingNotificationHub, {
        connectHandler: () => {
          connectToGroup(this.connection, client.id, 'ConnectToCuttingClientGroup');
        },
      });
      this.connection = connection;

      return callback
        .then(() => {
          this.connected$.next(true);
        })
        .catch(err => {
          this.connected$.next(false);
          throw err;
        });
    }

    return Promise.resolve(undefined);
  }

  disconnect(): void {
    if (this.connection) {
      this.connection.stop();
      this.connection = undefined;
    }
  }

  public updateHasCommonNotifications(): Promise<void> {
    const client = LocalStorageManager.client;

    if (!client) {
      this.connected$.next(false);
      return Promise.resolve();
    }

    return new Promise<void>((resolve, reject) => {
      this.connection
        .invoke(this.updateHasCommonNotificationsName, client.id)
        .then(() => {
          console.log(this.updateHasCommonNotificationsName + ' ^_^');
          resolve(undefined);
        })
        .catch(() => {
          console.log(this.updateHasCommonNotificationsName + ' error -_-');
          reject();
        });
    });
  }

  getCommonNotifications(): Observable<ICustomResponse<IClientCuttingNotification[]>> {
    return this.http.get(ApiLinks.notfications).pipe(customResponse<IClientCuttingNotification[]>());
  }

  markAsRead(notificationIds: number[]): Observable<void> {
    return this.http.post<void>(ApiLinks.notfications + '/mark-as-read', notificationIds);
  }

  markAllAsRead(): Observable<void> {
    return this.http.post<void>(ApiLinks.notfications + '/mark-as-read/all', undefined);
  }
}
